const ProcessDataJHT = (data) => {

    const newArray = data
        .filter(item => item.Cantidad === 0) // Filtrar solo si Cantidad es 0
        .map(item => ({
            No_Linea: item.No_Linea, // Cambiar "No_Linea" a "linea"
            No_Documento: item.No_Documento, // Cambiar "No_Documento" a "documento"
            No_Linea_Pedido: item.No_Linea_Pedido, // Cambiar "No_Linea_Pedido" a "lineaPedido"
            Tipo_Documento: item.Tipo_Documento, // Cambiar "Tipo_Documento" a "tipoDocumento"
            sku: item.No_Producto, // Cambiar "No_Producto" a "sku"
            qty: 1, // Cambiar "Cantidad" a "qty"
            serie: item.No_Serie, // Cambiar "No_Serie" a "serie"
            Estatus: item.Estatus // Cambiar "Estatus" a "estatus"
        }));

    // Convertir objeto a array y asignar No_Documento como "order"
    const orderDetails = {
        order: data[0].No_Documento,
        details: newArray
    };



    return orderDetails;
};

/* const data = [
    {
        "@odata.etag": "W/\"JzIwOzEwNTg4MDUzODA2ODc5ODI0NzU0MTswMDsn\"",
        "No_Linea": 1,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 10000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MTM1939-01N-LED 220V",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzE3NjU2OTA2NjcxMzc4NDExODA1MTswMDsn\"",
        "No_Linea": 2,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 10000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MTM1939-01N-LED 220V",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzYyNzkwMTU0NjIxNjc0NDcyNDAxOzAwOyc=\"",
        "No_Linea": 3,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 10000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MTM1939-01N-LED 220V",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEzMzQ3ODY4MzI2NjY2MDM0MjkxMTswMDsn\"",
        "No_Linea": 4,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 10000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MTM1939-01N-LED 220V",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzE5Njk5NzcxMTc0NTUwNjk3MjYxOzAwOyc=\"",
        "No_Linea": 5,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 10000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MTM1939-01N-LED 220V",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzkwMzg4Mjk5ODE5NTM2NTY3NzcxOzAwOyc=\"",
        "No_Linea": 6,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 10000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MTM1939-01N-LED 220V",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5Ozk0MjI1NzkwMTk5NTgzNTIzNTcxOzAwOyc=\"",
        "No_Linea": 7,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 20000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MEP1361-01US-LED",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEzODQ0MDAxNTM4MDM0NDA5MDMyMTswMDsn\"",
        "No_Linea": 8,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 20000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MEP1361-01US-LED",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzE4MjY1NDI0MDU2MTEwNDY1NzA3MTswMDsn\"",
        "No_Linea": 9,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 20000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MEP1361-01US-LED",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzQyNDAxMDI1MDA0NzY5NzA3NjYxOzAwOyc=\"",
        "No_Linea": 10,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 20000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MEP1361-01US-LED",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5Ozg2NjE1MjUwMTg1NTMwMjc0NDExOzAwOyc=\"",
        "No_Linea": 11,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 20000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MEP1361-01US-LED",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzQzNjY0NjUzNjEwMTA0NjIyMzYxOzAwOyc=\"",
        "No_Linea": 12,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 30000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MGM0600-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEwODU0ODU3OTMwOTA5NzQzODI5MTswMDsn\"",
        "No_Linea": 13,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 30000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MGM0600-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzY1MzYwOTY4MjYxNzg1MzIyODkxOzAwOyc=\"",
        "No_Linea": 14,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 40000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MGM0432-17",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE4OzI3MTI4NzE0MjUzNTE4MDAwNDE7MDA7Jw==\"",
        "No_Linea": 15,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 50000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MGM0396-17",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE4Ozk0ODI3MzU3OTU5Nzc4NTEyMzE7MDA7Jw==\"",
        "No_Linea": 16,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 60000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MGM0832-17",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzE4MjY3MjM4NjA2NTUzNTYzNjIxOzAwOyc=\"",
        "No_Linea": 17,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 70000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MGM0633-70000",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzI1MzI3Nzc3NjA1ODAzODg5MTcxOzAwOyc=\"",
        "No_Linea": 18,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 80000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MGM0595-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5Ozg5MzU0MzQ3OTQyMDM4NDY1NjgxOzAwOyc=\"",
        "No_Linea": 19,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 90000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MGM0398-17",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzEyMDkwMjY5OTIxMzIyMzE1MjAxOzAwOyc=\"",
        "No_Linea": 20,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 100000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MGM0763-17",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEyNzgxNDc1MDM4MTgwMDUzNTY5MTswMDsn\"",
        "No_Linea": 21,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 110000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MMS0105-17",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzE1OTc5NjYwNDAzMzk1MTMwNDY3MTswMDsn\"",
        "No_Linea": 22,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 120000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0487-39",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzcxMDkwNTc2NTc2NTA5MzkwODMxOzAwOyc=\"",
        "No_Linea": 23,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 130000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0309-70470",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEzNTk3NDUwMjI3NTUwMjIwNjc2MTswMDsn\"",
        "No_Linea": 24,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 130000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0309-70470",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEyODUyNzk3MjU4NTQxMzcyMTQzMTswMDsn\"",
        "No_Linea": 25,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 150000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0331-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5Ozg5MTQxNzM2NDk2MzM3NDc3NDExOzAwOyc=\"",
        "No_Linea": 26,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 160000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0324-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzE1NDAyNTY2MjE5NTMzMDI5MzM0MTswMDsn\"",
        "No_Linea": 27,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 160000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0324-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzgxOTk4MTQxNTI5MTIyMTE5MTYxOzAwOyc=\"",
        "No_Linea": 28,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 170000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0491-39",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzM2NjY1OTQxOTEwNTI2NzY0NjExOzAwOyc=\"",
        "No_Linea": 29,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 170000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0491-39",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEwMzU1MDA2ODcwMTY0MTU1NDc0MTswMDsn\"",
        "No_Linea": 30,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 180000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0450-39",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzU4MjE3ODY5MDgzMDQ2MjAwMTkxOzAwOyc=\"",
        "No_Linea": 31,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 180000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0450-39",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEyODU0MDA0MTg5NDEzMzQwMjIyMTswMDsn\"",
        "No_Linea": 32,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 190000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0439-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE4Ozg5NTY1MjY4NTYwMzA3MDE5OTE7MDA7Jw==\"",
        "No_Linea": 33,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 190000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0439-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzczODQwNDUyNTU1MDIzNTE3OTIxOzAwOyc=\"",
        "No_Linea": 34,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 190000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0439-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEzMzIzMTY2NTc1OTk1NDc3NDcwMTswMDsn\"",
        "No_Linea": 35,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 200000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFW0320-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzQwMTI4NDU0NDY3NTQ1MTQyMzUxOzAwOyc=\"",
        "No_Linea": 36,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 210000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MPL0049-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5Ozc0NjAwNzE0MDY1NDE1NzgzNjgxOzAwOyc=\"",
        "No_Linea": 37,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 220000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MPL0084-39",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzMzMTg0NTk4ODY3NDAxMzk5OTgxOzAwOyc=\"",
        "No_Linea": 38,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 230000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MPL0079-39",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzEwMjY2NDUxMjM1NDY4NTExNjM4MTswMDsn\"",
        "No_Linea": 39,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 240000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MPL0043-70400",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzIwOzE0NTkxNzAwOTI3NzMwMzcyMDY0MTswMDsn\"",
        "No_Linea": 40,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 250000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFC0059-00US",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5Ozk3OTYzOTE4MjI4MDcyNjQ2OTkxOzAwOyc=\"",
        "No_Linea": 41,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 250000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFC0059-00US",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    },
    {
        "@odata.etag": "W/\"JzE5OzUwMDEwODI3MTc4ODQxNTczMzQxOzAwOyc=\"",
        "No_Linea": 42,
        "No_Documento": "OV-00199",
        "No_Linea_Pedido": 250000,
        "Tipo_Documento": "Pedido Venta",
        "No_Producto": "MFC0059-00US",
        "Cantidad": 0,
        "No_Serie": "",
        "Estatus": " "
    }
]; */

/* const result = ProcessDataJHT({ data });
console.log(JSON.stringify(result, null, 4)); */


export default ProcessDataJHT;